import { AuthorizationStorage } from 'frontcore/domain/authorization/model/AuthorizationService.d'

const TOKEN_KEY = 'token'

export default class AuthorizationLocalStore implements AuthorizationStorage {

  get () {
    return localStorage.getItem(TOKEN_KEY)
  }

  set (token: string) {
    localStorage.setItem(TOKEN_KEY, token)
  }

  clear () {
    localStorage.removeItem(TOKEN_KEY)
  }

}
